import createActionTypes from './createActionTypes';

export const namespace = 'TRACKING';

export const types = createActionTypes(namespace, [
  'PROFILE_CONSENT_INIT',
  'PROFILE_CONSENT_UPDATE',
  'SET_SESSION_FLYER_ID',
  'SPLUNK',
  'GCLID',
  'STREAMFULLY',
  'STREAMFULLY_INIT',
  'STREAMFULLY_SETUP',
  'ERROR',
  'FB_Q',
  'FB_INIT',
  'FB_EVENT',
  'FB_CUSTOM',
  'GA_PAGEVIEW',
  'GAW_CONVERSION',
  'GTAG',
  'HIT_VIEWER_PERCENTAGE',
  'RETAILER_DATA_LAYER_OPEN_AND_VIEW',
  'RETAILER_DATA_LAYER_PAGE_VIEW',
  'RETAILER_DATA_LAYER_CLICKOUT_LINK_CLICKED',
  'PRODUCT_IMPRESSION',
]);

export const profileConsentInit = (profilingConsent) => ({
  type: types.PROFILE_CONSENT_INIT,
  payload: { profilingConsent },
});

export const profileConsentUpdate = (profilingConsent) => ({
  type: types.PROFILE_CONSENT_UPDATE,
  payload: { profilingConsent },
});

export const setSessionFlyerId = (flyerId) => ({
  type: types.SET_SESSION_FLYER_ID,
  payload: { flyerId },
});

export const trackSplunk = (entries) => ({
  type: types.SPLUNK,
  payload: {
    entries,
  },
});

export const trackGclid = (entries) => ({
  type: types.GCLID,
  payload: {
    entries,
  },
});

export const trackStreamfully = (entries) => ({
  type: types.STREAMFULLY,
  payload: { entries },
});

export const trackStreamfullyInit = (entries) => ({
  type: types.STREAMFULLY_INIT,
  payload: {
    entries,
  },
});

export const trackStreamfullySetup = (payload) => ({
  type: types.STREAMFULLY_SETUP,
  payload,
});

export const trackingError = (error, action) => ({
  type: types.ERROR,
  payload: {
    error,
    action,
  },
});

export const fbQ = (...args) => ({
  type: types.FB_Q,
  payload: { args },
});

export const fbInit = (pixel) => ({
  type: types.FB_INIT,
  payload: { pixel },
});

export const fbEvent = (name, params) => ({
  type: types.FB_EVENT,
  payload: { name, params },
});

export const fbCustom = (name, params) => ({
  type: types.FB_CUSTOM,
  payload: { name, params },
});

export const gaPageview = (location) => ({
  type: types.GA_PAGEVIEW,
  payload: { location },
});

export const gawConversion = (label) => ({
  type: types.GAW_CONVERSION,
  payload: { label },
});

export const gtag = (...args) => ({
  type: types.GTAG,
  payload: { args },
});

export const hitViewerPercentage = (flyerId, reachedPercentage) => ({
  type: types.HIT_VIEWER_PERCENTAGE,
  payload: { flyerId, reachedPercentage },
});

export const retailerDataLayerOpenAndView = (currentPages) => ({
  type: types.RETAILER_DATA_LAYER_OPEN_AND_VIEW,
  payload: { currentPages },
});

export const retailerDataLayerPageView = (pages) => ({
  type: types.RETAILER_DATA_LAYER_PAGE_VIEW,
  payload: {
    pages,
  },
});

export const retailerDataLayerClickoutLinkClicked = (tagId) => ({
  type: types.RETAILER_DATA_LAYER_CLICKOUT_LINK_CLICKED,
  payload: {
    tagId,
  },
});

export const trackProductImpression = (tagId) => ({
  type: types.PRODUCT_IMPRESSION,
  payload: {
    tagId,
  },
});
